import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { AttributeService } from 'src/app/main/dynamic/service/attribute.service';

@Component({
  selector: 'app-switch-select-multiple',
  templateUrl: './switch-select-multiple.component.html',
  styleUrls: ['./switch-select-multiple.component.scss']
})
export class SwitchSelectMultipleComponent extends ComponentBase implements OnInit {

  
  Items: Item[];
  SelectedItems: Item[];

  checked: AttributeModel;
  textNotChecked: string = "";

  constructor(private attributeService: AttributeService) { super() }

  ngOnInit() {

    setTimeout(() => {
      this.configureChecked();
      this.configSelect();
    }, 3500);

    this.textNotChecked = this.getOptionByKey(this.attribute, "TextNotChecked");      
  }

  get isCheched(): boolean
  {
    if (!this.checked)
      return false;

     return this.checked.value.toLowerCase() == "true";
  }

  set value(checked: boolean)
  {
      this.checked.value = String(checked);
  }

  onValueChange(value: boolean) {
    this.attribute.value = null;
    this.SelectedItems = null;

    this.checked.value = value.toString();

    this.emit({ attribute: {
      value: this.checked.value,
      key: this.attribute.key,
      type: this.attribute.type
    }});
  }

  private configSelect(){
    this.SelectedItems = [];

    this.Items = this.attribute
                     .attributes
                     .filter(a => a.type == "option")
                     .map(a => new Item(a.key, a.value));
    
    let selecteds = this.attribute.value ? this.attribute.value.split(',') : [];

    selecteds.forEach(value => {
      
      this.SelectedItems.push(this.Items.find(i => i.Value == value));

    });
  }

  private configureChecked() {

      this.checked = this.attributeService.findBy("checked", this.attribute.attributes);
  }

  ngChangedSelect() {
    
    this.attribute.value = this.SelectedItems.map(i => i.Value).join(",");
    
   }

}

class Item {

  constructor(public Key: string, public Value: string){
    
  }
}
